import React, { useEffect } from 'react';
import RsvpForm from '../RsvpForm';
import { guestService } from '../../services/db';
import './RsvpFormElement.css';

function RsvpFormElement({ element, isPreviewMode, invitationId, eventId }) {
  const [submitted, setSubmitted] = React.useState(false);
  const [formError, setFormError] = React.useState('');
  
  // Add console logs to check when component mounts and what props it receives
  useEffect(() => {
    console.log('RsvpFormElement mounted with props:', {
      isPreviewMode,
      invitationId: invitationId || 'undefined',
      eventId: eventId || 'undefined',
      element
    });
  }, [isPreviewMode, invitationId, eventId, element]);
  
  const handleSubmit = async (formData) => {
    console.log('RsvpFormElement: Form submitted with data:', formData);
    console.log('RsvpFormElement: Current context:', { isPreviewMode, invitationId, eventId });
    
    // Don't attempt to save in edit mode
    if (!isPreviewMode) {
      console.log('RsvpFormElement: Not in preview mode, simulating successful submission');
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
      return;
    }
    
    try {
      // Check if we have the required IDs before submitting
      if (!eventId) {
        console.error('RsvpFormElement: Cannot submit RSVP - eventId is undefined');
        setFormError('Error: Event ID is missing. Please try again later or contact support.');
        return;
      }
      
      if (!invitationId) {
        console.error('RsvpFormElement: Cannot submit RSVP - invitationId is undefined');
        setFormError('Error: Invitation ID is missing. Please try again later or contact support.');
        return;
      }
      
      console.log('RsvpFormElement: Saving RSVP to database with IDs:', { eventId, invitationId });
      
      // Save RSVP to database
      await guestService.create({
        eventId,
        invitationId,
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email || null,
        phone: formData.phone || null,
        guestCount: formData.guestCount,
        rsvpStatus: 'attending',
        message: formData.message || '',
        submittedAt: new Date().toISOString()
      });
      
      console.log('RsvpFormElement: RSVP saved successfully');
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
    } catch (error) {
      console.error("RsvpFormElement: Error saving RSVP:", error);
      setFormError("There was an error submitting your RSVP. Please try again.");
    }
  };

  const { 
    backgroundColor = '#ffffff',
    borderColor = '#e5e7eb',
    borderRadius = '8px',
    boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05)'
  } = element.style || {};

  const formStyle = {
    backgroundColor,
    borderColor,
    borderRadius,
    boxShadow
  };

  return (
    <div className="rsvp-form-element" style={formStyle}>
      {submitted ? (
        <div className="rsvp-success">
          <h3>Thank You!</h3>
          <p>Your RSVP has been submitted successfully.</p>
        </div>
      ) : (
        <>
          {formError && (
            <div className="rsvp-form-error">
              <p>{formError}</p>
            </div>
          )}
          <RsvpForm onSubmit={handleSubmit} disabled={!isPreviewMode} />
        </>
      )}
    </div>
  );
}

export default RsvpFormElement; 